/** Shared positioning + mutual exclusion for floating help / feedback / chat docks. */

export const FLOATING_DOCK_EVENT = 'rentalyzer:floating-dock';

/** Panel width that fits the viewport when the dock is anchored near the right edge. */
export const DOCK_PANEL_WIDTH =
  'w-[min(calc(100vw-1.5rem),22rem)] max-w-[calc(100vw-1.5rem)]';

/**
 * Shared bottom inset for the horizontal FAB row (clears mobile browser chrome).
 */
export const DOCK_BOTTOM =
  'bottom-[calc(1.25rem+env(safe-area-inset-bottom,0px))]';

/**
 * Horizontal stack from bottom-right (chat rightmost, then feedback, then help).
 * Offsets account for 56px (w-14) FABs + 12px gap.
 */
export const DOCK_RIGHT = {
  chat: 'right-3 sm:right-4',
  feedback: 'right-[5rem] sm:right-[5.5rem]',
  help: 'right-[9.25rem] sm:right-[10rem]',
};

/** Panels always open from the right edge (same as chat FAB), above the FAB row. */
export const DOCK_PANEL_RIGHT = DOCK_RIGHT.chat;

export const DOCK_PANEL_BOTTOM =
  'bottom-[calc(5rem+env(safe-area-inset-bottom,0px))]';

/** Keep open panels inside the visible viewport above the FAB row. */
export const DOCK_PANEL_MAX_H =
  'max-h-[min(32rem,calc(100dvh-6.5rem-env(safe-area-inset-bottom,0px)-env(safe-area-inset-top,0px)))]';

export const DOCK_PANEL_HEIGHT =
  'h-[min(70dvh,540px)] max-h-[calc(100dvh-6.5rem-env(safe-area-inset-bottom,0px)-env(safe-area-inset-top,0px))]';

export function announceDockOpen(id) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(FLOATING_DOCK_EVENT, { detail: { id } }));
}
